import { render, staticRenderFns } from "./SeriesAudiovisualPlayer.vue?vue&type=template&id=bcb43156&"
import script from "./SeriesAudiovisualPlayer.vue?vue&type=script&lang=js&"
export * from "./SeriesAudiovisualPlayer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports